import { Page, PagePermissionName } from '../types/app';
import { FleetJobType, FleetServiceStatus, FleetTriggerType } from '../types/fleet';
import { getOptionsFromObject } from '../utils/objects';

export const FLEET_ROUTES_SECTION_ID = 'myFleet';
export const FLEET_HOME_ROUTE_ID = 'fleetHome';
export const FLEET_HOME_ROUTE = '/mi-flota';

export const FLEET_ASSETS_PAGE: Page = {
  id: 'fleetAssets',
  name: 'Mi flota',
  icon: 'garage',
  route: '/:id/mi-flota',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetAssets',
};
export const FLEET_DRIVERS_PAGE: Page = {
  id: 'fleetDrivers',
  name: 'Conductores',
  icon: 'group',
  route: '/:id/mi-flota/conductores',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetDrivers',
};
export const FLEET_DRIVER_PAGE: Page = {
  id: 'fleetDriver',
  name: 'Conductor',
  icon: 'group',
  route: '/:id/mi-flota/conductores/:driverId/:tab',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetDrivers',
};
export const FLEET_SERVICES_PAGE: Page = {
  id: 'fleetServices',
  name: 'Servicios',
  icon: 'safety_check',
  route: '/:id/mi-flota/servicios',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetServices',
};
export const FLEET_MAINTENANCE_TYPES_PAGE: Page = {
  id: 'fleetMaintenanceTypes',
  name: 'Mantenimientos',
  icon: 'build_cirlce',
  route: '/:id/mi-flota/tipos-de-mantenimiento',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetMaintenanceTypes',
  pageTitle: 'Tipos de mantenimiento',
};
export const FLEET_REPORTS_PAGE: Page = {
  id: 'fleetReports',
  name: 'Reportes',
  icon: 'bar_chart',
  route: '/:id/mi-flota/reportes',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetReports',
};
export const FLEET_SERVICE_REPORTS_PAGE: Page = {
  id: 'fleetServiceReport',
  name: 'Reportes de servicios',
  route: '/:id/mi-flota/reportes/servicios',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetReports',
};
export const FLEET_OPERATIONAL_REPORTS_PAGE: Page = {
  id: 'fleetOperationalReport',
  name: 'Reportes de operaciones',
  route: '/:id/mi-flota/reportes/operaciones',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetReports',
};
export const FLEET_DOWNLOADS_PAGE: Page = {
  id: 'fleetDownloads',
  name: 'Descargas reportes',
  pageTitle: 'Descargas de reportes',
  icon: 'cloud_download',
  route: '/:id/mi-flota/descargas-de-reportes',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetDownloads',
};
export const FLEET_RULES_PAGE: Page = {
  id: 'fleetRules',
  name: 'Reglas',
  icon: 'settings_application',
  route: '/:id/mi-flota/reglas-de-mantenimiento',
  permissionName: PagePermissionName.myFleet,
  navKey: 'fleetRules',
  pageTitle: 'Reglas de mantenimiento',
};

export const FLEET_ROOT_PAGES: Page[] = [
  FLEET_ASSETS_PAGE,
  FLEET_DRIVERS_PAGE,
  FLEET_SERVICES_PAGE,
  FLEET_RULES_PAGE,
  FLEET_MAINTENANCE_TYPES_PAGE,
  FLEET_REPORTS_PAGE,
  FLEET_DOWNLOADS_PAGE,
];

export const FLEET_ROOT_PAGE_IDS = FLEET_ROOT_PAGES.map((page) => page.id);

export const FLEET_ALL_PAGES: Page[] = [
  ...FLEET_ROOT_PAGES,
  FLEET_DRIVER_PAGE,
  FLEET_OPERATIONAL_REPORTS_PAGE,
  FLEET_SERVICE_REPORTS_PAGE,
];

export const FLEET_CATALOGS_SECTION_ID = 'catalogs';
export const FLEET_CATALOGS_PAGE_IDS: string[] = [FLEET_RULES_PAGE.id, FLEET_MAINTENANCE_TYPES_PAGE.id];

export const FLEET_SERVICE_STATUS_LABELS = {
  [FleetServiceStatus.next]: 'Siguiente',
  [FleetServiceStatus.required]: 'Requerido',
  [FleetServiceStatus.expired]: 'Expirado',
  [FleetServiceStatus.attended]: 'Atendido',
  [FleetServiceStatus.cancel]: 'Cancelado',
};

export const FLEET_SERVICE_STATUS_OPTIONS = getOptionsFromObject(FLEET_SERVICE_STATUS_LABELS);

export const FLEET_TRIGGER_TYPE_LABELS = {
  [FleetTriggerType.distance]: 'Distancia',
  [FleetTriggerType.days]: 'Días',
};

export const FLEET_TRIGGER_TYPE_OPTIONS = getOptionsFromObject(FLEET_TRIGGER_TYPE_LABELS);

export const FLEET_JOB_TYPE_LABELS = {
  [FleetJobType.maintenance]: 'Mantenimiento',
  [FleetJobType.repair]: 'Reparación',
};

export const FLEET_JOB_TYPE_OPTIONS = getOptionsFromObject(FLEET_JOB_TYPE_LABELS);
